export default {
  required: {
    message : "URL is required!",
    fn      : (input)=> {
      return input?.length},
  },

  url: {
    message : "URL is not valid!",
    fn      : (input, siteLink)=> {
      let regEx = /^(https?:\/\/)?([a-zA-Z0-9_-]+\.)+([a-zA-Z]{2,})(\/.*)?$/
      siteLink = siteLink.replace("https://", "");
      return regEx.test(input) && input.includes(siteLink);
    }
  }

}